let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cwlcF")).then(() => parcelRequire('8fhda'));